import React from 'react';
import { Check } from 'lucide-react';

/**
 * Brand-colored checkbox.
 * `relative` on the label keeps the sr-only input inside the label,
 * so it never causes extra page height / outer scroll.
 */
const CustomCheckbox = ({ checked, onChange, disabled = false, className = '' }) => (
    <label
        className={`relative inline-flex items-center ${
            disabled ? 'cursor-not-allowed' : 'cursor-pointer'
        } ${className}`}
    >
        <input
            type="checkbox"
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            className="peer sr-only"
        />
        <span
            className="flex h-5 w-5 items-center justify-center rounded border-2 border-gray-300 bg-white transition-colors
                       peer-checked:border-brand-500 peer-checked:bg-brand-500
                       peer-focus-visible:ring-2 peer-focus-visible:ring-brand-500/40
                       peer-disabled:opacity-50
                       dark:border-gray-600 dark:bg-gray-900"
        >
            <Check
                size={13}
                strokeWidth={3}
                className={`text-white transition-opacity ${checked ? 'opacity-100' : 'opacity-0'}`}
            />
        </span>
    </label>
);

export default CustomCheckbox;